"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_rawReceivableDocumentation.isIntermediateRecord(tape), `[tape.type:${tape.type}] does not match [artifactType:${types_1.artifactType}]`);
    const { id, externalFilename, artifactSlug, configuration } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            externalFilename,
            ...configuration,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node } = params;
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_rawReceivableDocumentation.isNode(node), `uiNodesToIntermediate: node is not a generatedBorrowingBaseReport node: ${node.metadata.tapeBuilderNodeType}`);
    const { tapeBuilderNodeId } = node.metadata;
    const { artifactSlug, externalFilename, ...restConfiguration } = node.configuration;
    const record = {
        id: tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        externalFilename,
        configuration: {
            ...restConfiguration,
        },
        creditFacilitySlug: null,
        loanProductSlug: null,
    };
    return { record, operationNode: null };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map